export default "__VITE_PUBLIC_ASSET__b518c904__"